import { render } from "./ValidasiDokumen.vue?vue&type=template&id=3d9234dc&ts=true"
import script from "./ValidasiDokumen.vue?vue&type=script&lang=ts"
export * from "./ValidasiDokumen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__